
import { TwoFactorAuthComponent } from './two-factor-auth.component';

export const TwoFactorAuthStates : Array<any> = [
  {
    component: TwoFactorAuthComponent,
    name     : 'app.two-factor-auth-login',
    url      : '/two-factor-authentication'
  }
];
